import * as React from "react";
import { listApiData } from "@hooks/utils/api";
import {
  SocialBusiness,
  SocialBusinessLineItem,
} from "@interfaces/socialBusiness";
import { decodeSocialBusiness } from "decoders/socialBusiness";
import {
  SocialCommitmentTypeHour,
  SocialCommitmentTypeSpend,
} from "@interfaces/commitment";

export const useSocialBusiness = (
  socialProcurementType?: SocialCommitmentTypeHour | SocialCommitmentTypeSpend
) => {
  const [socialBusinesses, setSocialBusinesses] = React.useState<
    SocialBusinessLineItem[]
  >([]);

  const [isSocialBusinessLoading, setIsSocialBusinessLoading] =
    React.useState<boolean>(false);
  const [error, setError] = React.useState<string | null>(null);

  const listSocialBusinesses = async (socialFactor: string): Promise<void> => {
    try {
      setIsSocialBusinessLoading(true);
      const organisationResult = await listApiData(
        "listSocialBusinesses",
        "socialBusiness",
        socialFactor
      );

      const socialBusinessLineItems = await Promise.all(
        organisationResult.data.map((p) =>
          decodeSocialBusiness(p as SocialBusiness)
        )
      );
      setSocialBusinesses(socialBusinessLineItems);
    } catch (e: any) {
      setError("Could not list organisations");
    } finally {
      setIsSocialBusinessLoading(false);
    }
  };

  const searchSocialBusinesses = async (
    socialFactor: SocialCommitmentTypeHour | SocialCommitmentTypeSpend
  ): Promise<void> => {
    try {
      setIsSocialBusinessLoading(true);
      const organisationResult = await listApiData(
        "searchSocialBusinesses",
        "socialBusiness",
        socialFactor
      );

      const socialBusinessLineItems = await Promise.all(
        organisationResult.data.map((p) =>
          decodeSocialBusiness(p as SocialBusiness)
        )
      );
      setSocialBusinesses(socialBusinessLineItems);
    } catch (e: any) {
      setError("Could not list organisations");
    } finally {
      setIsSocialBusinessLoading(false);
    }
  };

  React.useEffect(() => {
    if (socialProcurementType) {
      searchSocialBusinesses(socialProcurementType);
    } else {
      listSocialBusinesses("");
    }
  }, [socialProcurementType]);

  return {
    socialBusinesses,
    isSocialBusinessLoading,
    error,
  };
};
